import { BreakpointObserver } from '@angular/cdk/layout';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ApiService } from '@shared/services/api.service';
import { AppInitService } from '@shared/services/app-init.service';
import { AppService } from '@shared/services/app.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
  selector: 'aux-root',
  template: `
    <router-outlet />
  `,
})
export class AppComponent {
  private apiService = inject(ApiService);
  private appInitService = inject(AppInitService);
  private appService = inject(AppService);
  private breakpointObserver = inject(BreakpointObserver);
  private cdr = inject(ChangeDetectorRef);

  changePx(px: number) {
    const html = document.querySelector('html');

    if (html) {
      html.style.fontSize = `${px}px`;
    }
  }

  constructor() {
    this.changePx(14);
  }

  @HostListener('window:focus')
  sendFocusEvent() {
    this.appService.focusEvent$.next(null);
  }
}
